import React, { useState } from 'react'
import { Icon } from '@iconify/react'

const BoxButton = ({ box, classes, handleCategoryClick, isOpen }) => {
  const [selectedIndex, setSelectedIndex] = useState(0)

  const handleClick = index => {
    setSelectedIndex(index)
    handleCategoryClick(index)
  }

  return (
    <div className={classes.fixedButtonContainer} id="editor-drag-drop-menu">
      {box.map((item, index) => (
        <div
          className={`${classes.fixedButton} ${
            isOpen === true
              ? selectedIndex === index
                ? item.outline
                  ? classes.outline
                  : classes.active
                : ''
              : null
          }`}
          onClick={() => handleClick(index)}
          key={index}
        >
          <div className={classes.iconContainer}>
            <Icon width="24" height="24" icon={item.icon} />
            <span className={classes.label}>{item.category}</span>
          </div>
        </div>
      ))}
    </div>
  )
}

export default BoxButton
